import { updateState } from "../../utils/reduxUtils";
import { IReduxAction } from "../../views/interfaces";
import {
  SET_PERFORMANCE_PAGE_PERIOD,
  SET_SELECTED_LISTINGS,
  SET_USER_LISTINGS,
} from "../actions";
import { L30D } from "../../utils/constants/filterConstants";

const initialState = {
  period: L30D,
  listings: [],
  selectedListings: [],
};

export const performancePageReducer = (
  state = initialState,
  { type, payload }: IReduxAction
) => {
  switch (type) {
    case SET_PERFORMANCE_PAGE_PERIOD: {
      return updateState(state, payload);
    }
    case SET_USER_LISTINGS: {
      return updateState(state, payload);
    }
    case SET_SELECTED_LISTINGS: {
      return updateState(state, payload);
    }
    default: {
      return state;
    }
  }
};
